export default "__VITE_ASSET__CXvPkbV0__"